<template lang="html">
    <DatePicker :placement="placement" transfer v-model="date" :placeholder="placeholder" type="date" format="d/MM/yyyy"/>
</template>

<script>
export default {
  props: [
    'value',
    'placeholder',
    'placement'
  ],

  data() {
    return {}
  },

  computed: {
    date: {
      get () {
        return Date.maintain(this.value)
      },
      set (d) {
        var v = this.value
        if ((v && d && v == d.serializeLocal()) || (!v && !d)) return
        this.$emit('input', d ? d.serializeLocal() : null)
      }
    }
  }
}
</script>

<style lang="css">
</style>
